// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/base.scss'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import {Button} from 'mint-ui'
import Vant from 'vant'
import VueClipboard from 'vue-clipboard2'
import 'vant/lib/index.css'

Vue.component(Button.name, Button)

Vue.use(MintUI)
Vue.use(Vant)
Vue.config.productionTip = false
Vue.use(VueClipboard)
/* eslint-disable no-new */
new Vue({
  // el: '#app',
  router,
  // components: { App },
  // template: '<App/>',
  render: h =>h(App)
}).$mount("#app")
